import { render, staticRenderFns } from "./Opz2ClientDrawer.vue?vue&type=template&id=abb53cfa"
import script from "./Opz2ClientDrawer.vue?vue&type=script&lang=ts"
export * from "./Opz2ClientDrawer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports